import { useMutation } from 'react-query';

import { FeedbackQuestionIds } from '../../../../backend/src/feedback/feedback-questions';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface SubmitFeedbackParameters {
  questionId: FeedbackQuestionIds;
  response: string;
  freeText?: string;
  metadata?: Record<string, unknown>;
}

export const useSubmitFeedback = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const submitFeedback = useMutation(async ({ questionId, response, freeText, metadata }: SubmitFeedbackParameters) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { questionId, response, freeText, metadata },
    });

    const res = await fetch(`${APIBaseChronos}/api/feedback`, fetchConfig);

    if (!res.ok) {
      throw new Error('Failed to submit feedback');
    }

    return res.json();
  });

  return { submitFeedback };
};
